import axios from "axios";

export const http = axios.create({
	baseURL: "https://apicd.editoradobrasil.com.br/api/",
	//baseURL: 'http://192.168.1.6:6158/api/',
	// baseURL: 'https://awscdapi.editoradobrasil.com.br/api/',

	headers: {
		"Content-Type": "application/json",
	},
});

export const generateTokenAPI = axios.create({
	baseURL: "https://api.editoradobrasil.com.br/AccessTokenGeneration-API/api/",
	// baseURL: 'http://10.220.95.4:8040/api/',

	headers: {
		"Content-Type": "application/json",
	},
});
